import CampaignList from 'common/pages/campaign/CampaignList.tsx'

export const CampaignListAgency = (props: any) => <CampaignList {...props} mode={props.mode} agency/>